module.exports = __webpack_public_path__ + "static/media/back.4453e2a6.png";